import { gql } from "@apollo/client";

import tpl from "./signatureTemplate.ejs";

const signatureTemplate = tpl;

signatureTemplate.fragments = {
  user: gql`
    fragment signatureTemplate_user on User {
      id

      profile {
        email
        firstName
        lastName
        fullName
        picture
        job
        phone
      }
    }
  `,
};

export default signatureTemplate;
